<template>
    <BaseContainer>
       <h1 class="display-6 text-center">Linux Learning Layer (LLL)</h1>
    <BaseContentContainer>
   
  <!-- Intro Section -->
    <div class="lead text-center mb-5">
    Linux is the foundation for doing real, physical, system-level computing. It will multiply the usefulness of your existing coding skills and allow you to
    "Build cool tech projects".It is essential for moving from abstract coding to real-world, hands-on computing in fields like Cybersecurity, Embedded Systems/IoT, AI robotics, and tools like Raspberry Pi, drones, and more.
     Learning Linux comes with great benefits particularly in developing, controlling and deep interaction with the systems. 

    </div>
    <div class="row">
      <!-- Vertical Nav -->
      <div class="col-md-4 mb-3">
        <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
          <button
            v-for="(topic, index) in topics"
            :key="index"
            class="nav-link py-2 px-3 mb-2 text-start"
            :class="{ active: activeTab === index }"
            @click="activeTab = index"
            type="button"
            role="tab"
       
          >
            {{ topic.title }}
          </button>
        </div>
      </div>

      <!-- Tab Content -->
      <div class="col-md-8">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h5 class="card-title text-success">{{ topics[activeTab].title }}</h5>
            <!-- p class="card-text">{{ topics[activeTab].description }}</p -->
            <div class="card-text" v-html="topics[activeTab].description">   </div>
            <div>
            <br/>
            <InfoButtons v-if="topics[activeTab].title === '2. What you can do with Linux?'" />
              </div>
          
          </div>
        </div>
      </div>
    </div>
    
    </BaseContentContainer>
</BaseContainer>
   <!-- Render InfoButtons only on tab 2 -->
            
</template>

<script>
import InfoButtons from '@/views/misc/InfoButtons.vue'  // adjust path if needed
import mentalModelImg from '@/assets/images/digital_learning_ecosystem/linux_learning_layer/linux_mental_model_1.png';
import BaseContainer  from '@/components/BaseContainer.vue';
import BaseContentContainer  from '@/components/BaseContentContainer.vue';
export default {

name: 'OverviewView',
components: { InfoButtons ,  BaseContainer,BaseContentContainer,},

  data() {
    return {
      activeTab: 0,
      topics: [
        {
          title: '1. Why Learn Linux?',
          description: `
          </br>
          <p>Linux teaches you <strong>System Thinking</strong>.</p>
          <p>You’ll go from "writing code" to "deploying systems that interact with the world.</p>
          <p>That’s a huge mindset shift:</p>
          <ul>
          <li>From software-only to <b>software-powered systems</b>.</li>
          <li>From apps to <b>automation and real-world problem solving</b>.</li>
          </ul>
          `
        },
        {
          title: '2. What you can do with Linux?',
          description: `
            </br>
        <p>Click on the button to reveal more information about the specific technology domain.</p>
        <p> Without Linux, you miss the ground floor of control in Cloud servers (AWS, Azure, VPS), 
        Cybersecurity, Embedded Systems/IoT, AI robotics, Raspberry Pi, drones, and most headless devices.</p>
                      `

        },
        {
          title: '3. What mental model Linux helps you to build?',
          description:  
          `
          <br/>
          <p>Linux helps you understand the flow: <strong>Code → OS → Hardware</strong></p>
          <br/>
        <div>
          <img src="${mentalModelImg}" alt="Linux mental model"/>
        </div>
         <br/>
       <p> Without Linux:</p>
        <ul>
            <li><strong>This is a black box.</strong></li>
        </ul>
       <p> With Linux:</p>
        <ul>
            <li><strong>You can actually see and control each step.</strong></li>
         </ul>

        <p>This builds deep understanding and makes you a more effective learner and innovator.
           `
           
        },
        {
          title: '4. Where to start to connect to Linux?',
          description: 
          `
          </br>
          <p>
          The best way to start learning with Linux is by using 
          <strong>WSL2 (Windows Subsystem for Linux)</strong>.</p> 
             <p>
          It allows you to run a full Linux environment directly inside Windows without 
          needing a separate Linux computer. This is perfect for learning and project work
           because students can smoothly switch between Windows tools 
           (like Google Classroom, Google Drive, VS Code, or web browsing) 
           and Linux commands in the same device. WSL2 is lightweight, 
           easy to install, and supports real Linux development tools, making it ideal
            for learning programming, cybersecurity, IoT projects, and servers.
            </p> 
             <p>
            Later, students can move to dedicated Linux machines 
            or cloud servers, but WSL2 is the most practical 
            and accessible starting point.</p> 


            `
        },
        {
          title: '5. How to start communicating with Linux?',
          description: 
           `<p>Under process...coming soon!</p>
         
        `
        },
        {
          title: '6. How to work on Practical Project?',
          description: 
          `
            <p>Under process...coming soon!</p>
             
          `      
},
      
      ]
    };
  }
};



</script>

<style scoped>
.nav-link {
  cursor: pointer;
}
.card-title {
  font-weight: 600;
}
.nav-link {
  background-color: #f8f9fa !important;
  color: #000 !important;
  border: 1px solid #dee2e6 !important;
}

.nav-link:hover {
  background-color: #e9f5ee !important;
  color: #000 !important;
}


.nav-link.active {
  background-color: #198754 !important;
  color: #fff !important;
  border-color: #198754 !important;
  font-weight: 600;
}

.bg-image-1 {
  background-image: url('@/assets/images/digital_learning_ecosystem/linux_learning_layer/linux_mental_model_1.png'); /* Replace with your image */
}





</style>
